import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import { IntegrationViewButton } from "../ButtonTheme";
import './IntegrationView.css';

function IntegrationView() {
    const imagePath1 = process.env.PUBLIC_URL + './integration1.png';
    const imagePath2 = process.env.PUBLIC_URL + './integration2.png';
    const imagePath3 = process.env.PUBLIC_URL + './integration3.png';

    const [mainImage, setMainImage] = useState(imagePath1);

    useEffect(() => {
        // Set initial larger font size for step 1
        const step1Element = document.querySelector('.integration-step[data-id="1"]');
        if (step1Element) {
            step1Element.classList.add('clicked');
        }
    }, []);

    function handleClick(imageName, elementId) {
        setMainImage(imageName);

        // Remove the 'clicked' class from all steps
        document.querySelectorAll('.integration-step').forEach(step => {
            step.classList.remove('clicked');
        });

        // Add the 'clicked' class to the clicked step
        const clickedElement = document.querySelector(`.integration-step[data-id="${elementId}"]`);
        if (clickedElement) {
            clickedElement.classList.add('clicked');
        }
    }
    
    return (
        <div className="IntegrationView">
            <Grid className="integration-container" container>
                <Grid className="integration-title" item xs={12} md={12} xl={12}>
                    <p className='integration-title-text'>
                        Find us on the Shopify App Store and you're one click away
                    </p>
                </Grid>

                <Grid className="integration-steps-container" item md={6} xl={6} align='center'>                    
                    <div className="integration-step" data-id="1" onClick={() => handleClick(imagePath1, '1')}>
                        01 Install Blankwall from the App Store
                    </div>
                    <div className="integration-step" data-id="2" onClick={() => handleClick(imagePath2, '2')}>
                        02 Add Blankwall button to your store and your entire catalog is instantly supported
                    </div>
                    <div className="integration-step" data-id="3" onClick={() => handleClick(imagePath3, '3')}>
                        03 Enjoy color accurate and true to size dimensions AR preview
                    </div>
                </Grid>

                <Grid item xs={12} md={6} xl={6} align='center'>
                    <div className="integration-image-container">
                        <img className="integration-image" id="mainImage" src={mainImage} alt="Main" />
                    </div>
                </Grid>

                <Grid className="integration-subtitle" item xs={12} md={12} xl={12}>
                    <p className='integration-title-text'>
                        Talk to us about building Blankwall into your custom website.
                    </p>
                    <IntegrationViewButton className='integration-title-button' variant='outlined' href="/contact">
                        Let's Chat
                    </IntegrationViewButton>
                </Grid>
            </Grid>
        </div>
    );
}

export default IntegrationView;
